import request from "./qsRequest";
import { ElMessage } from 'element-plus'

export default function getNewsCount() {
    async function getCount() {
        try {
            const res = await request.get('/newsCount')
            if (res.data.status == 1) {
                return res.data.data
            } else {
                ElMessage({
                    showClose: true,
                    message: `${res.data.info}`,
                    type: 'error',
                })
                // console.log(res)
            }
        } catch (err: any) {
            //alert(err)
        }
    }

    return {
        getCount
    }
}